<div class="page-wrapper">
    <div class="mid-component-section">
        <div class="logo">
            <img src="assets/images/icpc-logo.png" width="75px" alt="logo">
        </div>
        <div class="invite-text">
            <div class="invite-heading mt-2 mb-1 has-text-primary">DOI Invitation Page</div>
            <div>Welcome <b>John</b>, you have been invited to directorate of intelligence through your email <b>john@comsoftltd.com</b>. </div>
                <div>Please enter your password:</div>

        </div>

        <form [formGroup]="inviteForm" class="password">
            <div class="mt-1">
                <div>
                    <div class="custom-label">Enter Password</div>
                    <div>
                        <mat-form-field class="custom-form-field" floatLabel="never" appearance="outline">
                            <input type="text" formControlName="password"  matInput placeholder="Enter Password">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="mt-1">
                <div>
                    <div class="custom-label">Confirm Password</div>
                    <div>
                        <mat-form-field class="custom-form-field" floatLabel="never" appearance="outline">
                            <input type="text" formControlName="confirm"  matInput placeholder="Re-type Password">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <button mat-flat-button class="colour-button" routerLink="/app">
                Submit Password
            </button>
        </form>

    </div>

    <div class="footer">
        Copyright &copy; {{currentDate}}. Economic and Financial Crimes Commission (EFCC). All Rights Reserved.
    </div>

</div>



